import * as React from 'react';
export function useActions(state, innerRef, dispatch) {
    var toggleOpen = React.useCallback(function toggleOpen() {
        if (state.status === 'open') {
            dispatch({ type: 'SET_CLOSING' });
        }
        if (state.status === 'closed' && innerRef.current !== null) {
            dispatch({
                type: 'SET_OPENING',
                height: innerRef.current.getBoundingClientRect().height
            });
        }
    }, [state.status]);
    var setOpen = React.useCallback(function setOpen(open) {
        if (open && innerRef.current !== null) {
            dispatch({
                type: 'SET_OPENING',
                height: innerRef.current.getBoundingClientRect().height
            });
        }
        else {
            dispatch({ type: 'SET_CLOSING' });
        }
    }, [state.status]);
    return {
        toggleOpen: toggleOpen,
        setOpen: setOpen
    };
}
//# sourceMappingURL=hooks.js.map